import React from 'react'
import cn from 'classnames'

import styles from './styles.module.css'

interface NavigationBarProps {
  children: React.ReactNode
  offerCTA?: React.ReactNode
}

const NavigationBar: React.FC<NavigationBarProps> = props => {
  const { children, offerCTA } = props

  return (
    <nav className={cn(styles.navigationBar)}>
      <ul className={styles.scrollContainer}>{children}</ul>
      {offerCTA && <div className={cn(styles.offerCTA)}>{offerCTA}</div>}
    </nav>
  )
}

export default NavigationBar
